package app.nestbridge.domain.identity.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class ProfessionalProfile(
    val id: String,
    val userId: String,
    val displayName: String,
    val credentials: List<String> = emptyList(),
    val affiliation: String,
    val primaryServiceProvided: ProfessionalServiceType,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
)
